(function () {
  'use strict';

  const OPEN_CLASS = 'is-open';
  const BODY_CLASS = 'rc-drawer-open';

  function getDrawer(id) {
    return document.getElementById(id);
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_CLASS);
    // Focus the close button for accessibility
    const closeBtn = drawer.querySelector('.rc-size-guide-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_CLASS);
    // Reset aria-expanded on all triggers pointing to this drawer
    if (drawer.id) {
      document.querySelectorAll(`[data-drawer-target="${drawer.id}"]`).forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function init() {
    // ===== Open: trigger button with data-drawer-target =====
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-drawer-target]');
      if (!trigger) return;
      const drawer = getDrawer(trigger.getAttribute('data-drawer-target'));
      openDrawer(drawer);
      trigger.setAttribute('aria-expanded', 'true');
    });
    // ===== Close: close button OR overlay (data-drawer-close) =====
    document.addEventListener('click', function (e) {
      const closeEl = e.target.closest('[data-drawer-close]');
      if (!closeEl) return;
      const drawer = closeEl.closest('.rc-size-guide-drawer');
      closeDrawer(drawer);
    });
    // ===== Close: click outside the drawer panel =====
    document.addEventListener('click', function (e) {
      document.querySelectorAll(`.rc-size-guide-drawer.${OPEN_CLASS}`).forEach(function (drawer) {
        const panel = drawer.querySelector('.rc-size-guide-drawer__panel');
        // If click is inside the panel or on a trigger, do nothing
        if (panel && panel.contains(e.target)) return;
        if (e.target.closest('[data-drawer-target]')) return;
        closeDrawer(drawer);
      });
    });
   // ===== Rings Size guide =====
    $('.tab-content-inner:first').addClass('active');
    $('.tab-link-inner:first').addClass('active');

    $('.tab-link-inner').click(function () {
      var tab_id = $(this).attr('data-tab');
      $('.tab-link-inner').removeClass('active');
      $('.tab-content-inner').removeClass('active');
      $(this).addClass('active');
      $("#" + tab_id).addClass('active');
    });
    // ===== Close: Escape key =====
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll(`.rc-size-guide-drawer.${OPEN_CLASS}`).forEach(closeDrawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();